import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

import HeaderImagesComponent from "corp-site/components/HeaderImagesComponent";
import 'assets/scss/upward.scss';
import { ThemeContext } from "./context/ThemeContext";
import EmployerMain from "./employer/components/EmployerMain";
import HomeHeader from "./components/Header";
import HomeFooter from "./components/Footer";
import CountDisplay from "./employer/components/CountDisplay";
import WorkWithCompanies from "./employer/components/WorkWithCompanies";
import EmployerDetails from "./employer/components/EmployerDetails";
import PostToBoards from "./employer/components/PostToBoards";
import VerticalGetAll from "./verticals/components/VerticalGetAll";
import FindAndInvite from "./employer/components/FindAndInvite";
import {openCmpDrawer} from "../../components/OsanoSupport";
import Banner from "../../components/BottomBanner";

import EmployerSignIn from "./employer/signin";
import EmployerRegistration from "./employer/register/EmployerRegistration";
import EmployerPasswordResetConfirm from "./employer/resetPassword";

import JCNotification from "./employer/jcnotification";

import PricingOverlay from "./employer/pricing/PricingMain";
import GustoOverlay from "./employer/gusto/GustoMain";

const defaultUserParams = { "id": null, "token": null };

const EmployerHome = withRouter(( props ) => {
    const [ showBanner, setShowBanner ] = useState(true);
    const [ showRegister, setShowRegister ] = useState(false);
    const [ showSignin , setShowSignin ] = useState( false );
    const [ showJobcase , setShowJobcase ] = useState( false );
    const [ showPricing , setShowPricing ] = useState( false );
    const [ showGusto , setShowGusto ] = useState( false );
    const [ showPasswordReset, setShowPassword ] = useState(false);
    const [ userParams, setUserParams ] = useState(defaultUserParams);
    const qs = queryString.parse(props.location.search);

    const referrer =  document.referrer ? document.referrer : "";

    useEffect(()=>{
      if (window.fcWidget) {
        if( window.fcWidget.isInitialized() ){
          window.fcWidget.setTags( ["employer"] );
          window.fcWidget.setConfig({
            headerProperty: {
              backgroundColor: '#EE9E07',
              foregroundColor: '#FFFFFF',
            },
            hideFAQ: false
          });
        } else {
          window.fcWidget.init({
            token: "89235af7-6f07-42fa-b55a-d84335e71b51",
            host: "https://wchat.freshchat.com",
            tags: ["employer"],
            config: {
              headerProperty: {
                backgroundColor: '#EE9E07',
                foregroundColor: '#FFFFFF',
              }
            }
          });
        }
      }
    },[]);

    useEffect(()=>{
        if( qs && qs.register && qs.register === "y" ){
            setShowRegister( true );
        }
        if (qs && ((qs.signin && qs.signin === "y") || ( qs.error && qs.error === "vr" ) )) {
            setShowSignin(true);
        }
        if (qs && qs.pricing && qs.pricing === "y") {
            setShowPricing(true);
        }
        if (qs && qs.utm_source && qs.utm_source === "Gusto") {
            setShowGusto(true);
        }
        if (qs && qs.token && qs.id && qs.token.length > 0 && qs.id.length > 0) {
            setShowPassword( true );
        }
        if( qs && qs.liveChat && qs.liveChat === "y" ){
          if( window.fcWidget && window.fcWidget.isInitialized() ){
            window.fcWidget.open();
          }
        }
        if((qs && qs.utm_source && (qs.utm_source === "Jobcase" || qs.utm_source === "jobcase")) || referrer.toLowerCase().indexOf('jobcase') > -1){
          setShowJobcase(true);
        }
        return () => {
            setShowRegister( false );
            setShowSignin( false );
            setShowPricing( false );
            setShowGusto( false );
            setShowPassword( false );
            setUserParams( null );
            setShowJobcase(false);
        }
    },[qs]);

    const closeBanner = (e) => {
      e.preventDefault();
      document.cookie = "banner=true";
      setShowBanner(false);
    }

    return (
      <Fragment>
        <ThemeContext.Provider value="orange">
          <HeaderImagesComponent />
          <Helmet>
            <title>Post a Job | Upward for Employers.</title>
            <meta
              name="keywords"
              content="Upward Solutions for Employers"
            />
          </Helmet>
          <HomeHeader employersActive/>
          {(new Date("2023-3-28") >= new Date()) && (new Date() >= new Date("2023-2-12")) && showBanner && <>
            <div class="container-45 w-container"><div class="div-block-86"><div data-w-id="87446ac1-3847-a010-f17a-29b8443f4627" style={{"display": "flex"}}  class="notification"><div class="top-bar preview-page" style={{"opacity":"1"}}><div class="top-bar-text max-w-mobile">Upward is now part of Jobcase! Go&nbsp;to <a href="https://www.jobcase.com/hire/index.html" target="_blank" class="link-7">Jobcase.com/hire</a></div><img onClick={closeBanner} src="https://uploads-ssl.webflow.com/6047ae248869be5fe03c51ad/61d5dfa2af35124b0f3699e4_close.png" loading="lazy" width="12" data-w-id="87446ac1-3847-a010-f17a-29b8443f462b" alt="" class="ic-close" /></div></div></div></div>
          </>}
          <EmployerMain/>
          <CountDisplay/>
          <WorkWithCompanies/>
          <PostToBoards/>
          <FindAndInvite/>
          <EmployerDetails/>
          <VerticalGetAll/>
          <Banner />
          <HomeFooter openCmpDrawer={openCmpDrawer}/>
          {showSignin && <EmployerSignIn/>}
          {showRegister && (
            <EmployerRegistration accountType="ENTERPRISE_FREE" />
          )}
          {showJobcase && <JCNotification setShowJobcase={setShowJobcase} />}
          {showPricing && <PricingOverlay/>}
          {showGusto && <GustoOverlay/>}
          {showPasswordReset && <EmployerPasswordResetConfirm /> }
        </ThemeContext.Provider>
      </Fragment>
    );
});


export default EmployerHome;
